import { TileEntrySubmission } from "../../models/app/Tile";

export const MOCK_PERUSALL_SUBMISSIONS: TileEntrySubmission[] = [
  {
    "userID":"22976781",
    "grade":"9.4",
    "meta":{
      "grade":"9.4",
      "viewing_time":"2 hours, 19 minutes",
      "active_reading_time":"1 hour, 38 minutes (71%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":26,
      "__question_upvotes_student_gave":4,
      "__comment_upvotes_student_received":11,
      "__question_upvotes_student_received":2
    },
    "entry_id":5
  },
  {
    "userID":"43754947",
    "grade":"7.8",
    "meta":{
      "grade":"7.8",
      "viewing_time":"27 minutes",
      "active_reading_time":"26 minutes (96%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":7,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":4,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"95366984",
    "grade":"2.4",
    "meta":{
      "grade":"2.4",
      "viewing_time":"1 hour, 41 minutes",
      "active_reading_time":"1 hour, 21 minutes (80%)",
      "__annotations":1,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":1
    },
    "entry_id":5
  },
  {
    "userID":"70805720",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"1 hour, 26 minutes",
      "active_reading_time":"1 hour, 23 minutes (96%)",
      "__annotations":9,
      "__comment_upvotes_student_gave":5,
      "__question_upvotes_student_gave":4,
      "__comment_upvotes_student_received":19,
      "__question_upvotes_student_received":14
    },
    "entry_id":5
  },
  {
    "userID":"74114284",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"8 hours, 10 minutes",
      "active_reading_time":"3 hours, 54 minutes (48%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":10,
      "__question_upvotes_student_gave":4,
      "__comment_upvotes_student_received":64,
      "__question_upvotes_student_received":3
    },
    "entry_id":5
  },
  {
    "userID":"97222205",
    "grade":"1.0",
    "meta":{
      "grade":"1",
      "viewing_time":0,
      "active_reading_time":0,
      "__annotations":0,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"66889858",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"7 hours, 11 minutes",
      "active_reading_time":"5 hours, 47 minutes (80%)",
      "__annotations":23,
      "__comment_upvotes_student_gave":16,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":19,
      "__question_upvotes_student_received":9
    },
    "entry_id":5
  },
  {
    "userID":"96600883",
    "grade":"7.3",
    "meta":{
      "grade":"7.3",
      "viewing_time":"6 minutes",
      "active_reading_time":"5 minutes (91%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":1,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"32324131",
    "grade":"9.3",
    "meta":{
      "grade":"9.3",
      "viewing_time":"12 hours, 51 minutes",
      "active_reading_time":"10 hours, 50 minutes (84%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":5,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":16,
      "__question_upvotes_student_received":2
    },
    "entry_id":5
  },
  {
    "userID":"41803722",
    "grade":"8.1",
    "meta":{
      "grade":"8.1",
      "viewing_time":"3 hours, 27 minutes",
      "active_reading_time":"2 hours, 52 minutes (83%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":38,
      "__question_upvotes_student_gave":14,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":4
    },
    "entry_id":5
  },
  {
    "userID":"81005245",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"5 hours, 42 minutes",
      "active_reading_time":"4 hours, 8 minutes (73%)",
      "__annotations":11,
      "__comment_upvotes_student_gave":13,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":5,
      "__question_upvotes_student_received":4
    },
    "entry_id":5
  },
  {
    "userID":"35251913",
    "grade":"1.0",
    "meta":{
      "grade":"1",
      "viewing_time":0,
      "active_reading_time":0,
      "__annotations":0,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"43219917",
    "grade":"7.5",
    "meta":{
      "grade":"7.5",
      "viewing_time":"1 hour, 47 minutes",
      "active_reading_time":"1 hour, 18 minutes (73%)",
      "__annotations":9,
      "__comment_upvotes_student_gave":1,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":3,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"59540503",
    "grade":"9.2",
    "meta":{
      "grade":"9.2",
      "viewing_time":"2 hours, 1 minute",
      "active_reading_time":"1 hour, 51 minutes (92%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":3,
      "__question_upvotes_student_gave":4,
      "__comment_upvotes_student_received":40,
      "__question_upvotes_student_received":1
    },
    "entry_id":5
  },
  {
    "userID":"52682411",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"9 hours, 57 minutes",
      "active_reading_time":"4 hours, 1 minute (40%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":4,
      "__comment_upvotes_student_received":10,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"29376337",
    "grade":"6.8",
    "meta":{
      "grade":"6.8",
      "viewing_time":"2 hours, 43 minutes",
      "active_reading_time":"1 hour, 27 minutes (53%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":8,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":3,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"74886921",
    "grade":"1.0",
    "meta":{
      "grade":"1",
      "viewing_time":"1 hour, 15 minutes",
      "active_reading_time":"21 minutes (28%)",
      "__annotations":0,
      "__comment_upvotes_student_gave":1,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"55571292",
    "grade":"7.5",
    "meta":{
      "grade":"7.5",
      "viewing_time":"9 hours, 10 minutes",
      "active_reading_time":"5 hours, 54 minutes (64%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":18,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":5
    },
    "entry_id":5
  },
  {
    "userID":"45844627",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"8 hours, 33 minutes",
      "active_reading_time":"5 hours (58%)",
      "__annotations":20,
      "__comment_upvotes_student_gave":9,
      "__question_upvotes_student_gave":7,
      "__comment_upvotes_student_received":56,
      "__question_upvotes_student_received":3
    },
    "entry_id":5
  },
  {
    "userID":"53036575",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"6 hours, 44 minutes",
      "active_reading_time":"4 hours, 45 minutes (71%)",
      "__annotations":21,
      "__comment_upvotes_student_gave":9,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":61,
      "__question_upvotes_student_received":13
    },
    "entry_id":5
  },
  {
    "userID":"16967126",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"1 hour, 39 minutes",
      "active_reading_time":"1 hour, 26 minutes (87%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":7,
      "__question_upvotes_student_gave":4,
      "__comment_upvotes_student_received":21,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"50326251",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"21 hours, 49 minutes",
      "active_reading_time":"3 hours, 46 minutes (17%)",
      "__annotations":14,
      "__comment_upvotes_student_gave":22,
      "__question_upvotes_student_gave":8,
      "__comment_upvotes_student_received":20,
      "__question_upvotes_student_received":1
    },
    "entry_id":5
  },
  {
    "userID":"23744275",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"6 hours, 6 minutes",
      "active_reading_time":"3 hours, 54 minutes (64%)",
      "__annotations":37,
      "__comment_upvotes_student_gave":13,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":62,
      "__question_upvotes_student_received":16
    },
    "entry_id":5
  },
  {
    "userID":"24585559",
    "grade":"5.0",
    "meta":{
      "grade":"5",
      "viewing_time":"17 minutes",
      "active_reading_time":"15 minutes (86%)",
      "__annotations":3,
      "__comment_upvotes_student_gave":16,
      "__question_upvotes_student_gave":14,
      "__comment_upvotes_student_received":4,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"54264654",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"6 hours, 34 minutes",
      "active_reading_time":"3 hours, 20 minutes (51%)",
      "__annotations":12,
      "__comment_upvotes_student_gave":26,
      "__question_upvotes_student_gave":6,
      "__comment_upvotes_student_received":18,
      "__question_upvotes_student_received":10
    },
    "entry_id":5
  },
  {
    "userID":"31665008",
    "grade":"4.7",
    "meta":{
      "grade":"4.7",
      "viewing_time":"39 minutes",
      "active_reading_time":"38 minutes (97%)",
      "__annotations":6,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"28624178",
    "grade":"1.0",
    "meta":{
      "grade":"1",
      "viewing_time":"2 hours, 11 minutes",
      "active_reading_time":"23 minutes (17%)",
      "__annotations":0,
      "__comment_upvotes_student_gave":4,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"45476233",
    "grade":"8.8",
    "meta":{
      "grade":"8.8",
      "viewing_time":"56 minutes",
      "active_reading_time":"49 minutes (87%)",
      "__annotations":17,
      "__comment_upvotes_student_gave":37,
      "__question_upvotes_student_gave":22,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":5
    },
    "entry_id":5
  },
  {
    "userID":"23400528",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"14 hours, 16 minutes",
      "active_reading_time":"4 hours, 6 minutes (29%)",
      "__annotations":15,
      "__comment_upvotes_student_gave":16,
      "__question_upvotes_student_gave":9,
      "__comment_upvotes_student_received":12,
      "__question_upvotes_student_received":20
    },
    "entry_id":5
  },
  {
    "userID":"86899376",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"7 hours",
      "active_reading_time":"2 hours, 15 minutes (32%)",
      "__annotations":20,
      "__comment_upvotes_student_gave":9,
      "__question_upvotes_student_gave":5,
      "__comment_upvotes_student_received":11,
      "__question_upvotes_student_received":20
    },
    "entry_id":5
  },
  {
    "userID":"28332183",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"58 minutes",
      "active_reading_time":"51 minutes (88%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":58,
      "__question_upvotes_student_gave":15,
      "__comment_upvotes_student_received":2,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"20380320",
    "grade":"5.3",
    "meta":{
      "grade":"5.3",
      "viewing_time":"1 hour, 54 minutes",
      "active_reading_time":"1 hour, 38 minutes (86%)",
      "__annotations":4,
      "__comment_upvotes_student_gave":8,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"21276717",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"2 hours, 9 minutes",
      "active_reading_time":"1 hour, 55 minutes (89%)",
      "__annotations":26,
      "__comment_upvotes_student_gave":10,
      "__question_upvotes_student_gave":5,
      "__comment_upvotes_student_received":11,
      "__question_upvotes_student_received":17
    },
    "entry_id":5
  },
  {
    "userID":"46666218",
    "grade":"8.1",
    "meta":{
      "grade":"8.1",
      "viewing_time":"2 hours, 27 minutes",
      "active_reading_time":"2 hours, 12 minutes (90%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":19,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":5,
      "__question_upvotes_student_received":1
    },
    "entry_id":5
  },
  {
    "userID":"35683215",
    "grade":"7.1",
    "meta":{
      "grade":"7.1",
      "viewing_time":"2 hours, 53 minutes",
      "active_reading_time":"2 hours, 33 minutes (89%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":16,
      "__question_upvotes_student_gave":4,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"42345728",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"7 hours, 8 minutes",
      "active_reading_time":"6 hours, 15 minutes (88%)",
      "__annotations":24,
      "__comment_upvotes_student_gave":11,
      "__question_upvotes_student_gave":12,
      "__comment_upvotes_student_received":9,
      "__question_upvotes_student_received":1
    },
    "entry_id":5
  },
  {
    "userID":"46647543",
    "grade":"7.0",
    "meta":{
      "grade":"7",
      "viewing_time":"3 hours, 24 minutes",
      "active_reading_time":"2 hours, 16 minutes (67%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":3,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"77161172",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"14 hours, 28 minutes",
      "active_reading_time":"7 hours, 28 minutes (52%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":12,
      "__question_upvotes_student_gave":9,
      "__comment_upvotes_student_received":4,
      "__question_upvotes_student_received":2
    },
    "entry_id":5
  },
  {
    "userID":"41149744",
    "grade":"1.0",
    "meta":{
      "grade":"1",
      "viewing_time":"52 minutes",
      "active_reading_time":"28 minutes (55%)",
      "__annotations":25,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":5,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"48905367",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"4 hours, 21 minutes",
      "active_reading_time":"3 hours, 5 minutes (71%)",
      "__annotations":15,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":55,
      "__question_upvotes_student_received":42
    },
    "entry_id":5
  },
  {
    "userID":"41393783",
    "grade":"9.6",
    "meta":{
      "grade":"9.6",
      "viewing_time":"2 hours, 17 minutes",
      "active_reading_time":"2 hours, 15 minutes (98%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":9,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":24,
      "__question_upvotes_student_received":2
    },
    "entry_id":5
  },
  {
    "userID":"55249485",
    "grade":"8.0",
    "meta":{
      "grade":"8",
      "viewing_time":"4 hours, 58 minutes",
      "active_reading_time":"2 hours, 30 minutes (50%)",
      "__annotations":6,
      "__comment_upvotes_student_gave":3,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":9,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"81888190",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"6 hours, 12 minutes",
      "active_reading_time":"6 hours, 1 minute (97%)",
      "__annotations":29,
      "__comment_upvotes_student_gave":65,
      "__question_upvotes_student_gave":16,
      "__comment_upvotes_student_received":13,
      "__question_upvotes_student_received":3
    },
    "entry_id":5
  },
  {
    "userID":"38152009",
    "grade":"4.6",
    "meta":{
      "grade":"4.6",
      "viewing_time":"1 hour, 20 minutes",
      "active_reading_time":"57 minutes (71%)",
      "__annotations":4,
      "__comment_upvotes_student_gave":11,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":7,
      "__question_upvotes_student_received":2
    },
    "entry_id":5
  },
  {
    "userID":"48470625",
    "grade":"8.2",
    "meta":{
      "grade":"8.2",
      "viewing_time":"13 minutes",
      "active_reading_time":"12 minutes (91%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":6,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"20936679",
    "grade":"4.2",
    "meta":{
      "grade":"4.2",
      "viewing_time":"1 hour, 43 minutes",
      "active_reading_time":"1 hour, 33 minutes (91%)",
      "__annotations":3,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":2,
      "__question_upvotes_student_received":2
    },
    "entry_id":5
  },
  {
    "userID":"96955357",
    "grade":"5.8",
    "meta":{
      "grade":"5.8",
      "viewing_time":"4 minutes",
      "active_reading_time":"4 minutes (99%)",
      "__annotations":9,
      "__comment_upvotes_student_gave":7,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":2
    },
    "entry_id":5
  },
  {
    "userID":"18298956",
    "grade":"8.0",
    "meta":{
      "grade":"8",
      "viewing_time":"1 hour, 10 minutes",
      "active_reading_time":"1 hour, 8 minutes (97%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":5,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"27034712",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"18 hours, 2 minutes",
      "active_reading_time":"7 hours, 7 minutes (39%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":22,
      "__question_upvotes_student_gave":4,
      "__comment_upvotes_student_received":7,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"90434281",
    "grade":"7.6",
    "meta":{
      "grade":"7.6",
      "viewing_time":"2 hours",
      "active_reading_time":"1 hour, 30 minutes (75%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"27817769",
    "grade":"7.5",
    "meta":{
      "viewing_time":"6 hours, 58 minutes",
      "active_reading_time":"2 hours, 2 minutes (29%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":4,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":7,
      "__question_upvotes_student_received":1
    },
    "entry_id":5
  },
  {
    "userID":"41898388",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"1 hour, 55 minutes",
      "active_reading_time":"1 hour, 54 minutes (99%)",
      "__annotations":9,
      "__comment_upvotes_student_gave":5,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":47,
      "__question_upvotes_student_received":0
    },
    "entry_id":5
  },
  {
    "userID":"76262947",
    "grade":"7.4",
    "meta":{
      "grade":"7.4",
      "viewing_time":"1 hour, 9 minutes",
      "active_reading_time":"1 hour, 7 minutes (98%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":18,
      "__question_upvotes_student_gave":4,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":6
    },
    "entry_id":5
  },
  {
    "userID":"22976781",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"5 hours",
      "active_reading_time":"2 hours; 16 minutes (45%)",
      "__annotations":9,
      "__comment_upvotes_student_gave":12,
      "__question_upvotes_student_gave":5,
      "__comment_upvotes_student_received":8,
      "__question_upvotes_student_received":1
    },
    "entry_id":6
  },
  {
    "userID":"43754947",
    "grade":"8.0",
    "meta":{
      "grade":"8",
      "viewing_time":"2 hours; 7 minutes",
      "active_reading_time":"2 hours (94%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":15,
      "__question_upvotes_student_gave":7,
      "__comment_upvotes_student_received":3,
      "__question_upvotes_student_received":2
    },
    "entry_id":6
  },
  {
    "userID":"95366984",
    "grade":"5.6",
    "meta":{
      "grade":"5.6",
      "viewing_time":"9 hours; 44 minutes",
      "active_reading_time":"3 hours; 29 minutes (36%)",
      "__annotations":4,
      "__comment_upvotes_student_gave":3,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"70805720",
    "grade":"9.9",
    "meta":{
      "grade":"9.9",
      "viewing_time":"2 hours; 7 minutes",
      "active_reading_time":"1 hour; 45 minutes (83%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":12,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":10,
      "__question_upvotes_student_received":8
    },
    "entry_id":6
  },
  {
    "userID":"74114284",
    "grade":"8.4",
    "meta":{
      "grade":"8.4",
      "viewing_time":"42 minutes",
      "active_reading_time":"39 minutes (94%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":21,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"97222205",
    "grade":"4.1",
    "meta":{
      "grade":"4.1",
      "viewing_time":"1 minute",
      "active_reading_time":"1 minute (90%)",
      "__annotations":3,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"66889858",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"18 hours; 15 minutes",
      "active_reading_time":"18 hours; 3 minutes (99%)",
      "__annotations":22,
      "__comment_upvotes_student_gave":12,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":25,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"96600883",
    "grade":"8.4",
    "meta":{
      "grade":"8.4",
      "viewing_time":"1 hour; 48 minutes",
      "active_reading_time":"1 hour; 31 minutes (85%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":9,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":2,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"32324131",
    "grade":"8.9",
    "meta":{
      "grade":"8.9",
      "viewing_time":"3 hours; 43 minutes",
      "active_reading_time":"1 hour; 58 minutes (53%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":1,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":11,
      "__question_upvotes_student_received":7
    },
    "entry_id":6
  },
  {
    "userID":"41803722",
    "grade":"6.9",
    "meta":{
      "grade":"6.9",
      "viewing_time":"1 hour; 9 minutes",
      "active_reading_time":"43 minutes (62%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":21,
      "__question_upvotes_student_gave":18,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":4
    },
    "entry_id":6
  },
  {
    "userID":"81005245",
    "grade":"9.6",
    "meta":{
      "grade":"9.6",
      "viewing_time":"1 hour; 49 minutes",
      "active_reading_time":"1 hour; 46 minutes (97%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":2,
      "__question_upvotes_student_gave":8,
      "__comment_upvotes_student_received":2,
      "__question_upvotes_student_received":4
    },
    "entry_id":6
  },
  {
    "userID":"35251913",
    "grade":"3.7",
    "meta":{
      "grade":"3.7",
      "viewing_time":"22 hours; 7 minutes",
      "active_reading_time":"11 hours; 41 minutes (53%)",
      "__annotations":1,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"43219917",
    "grade":"9.0",
    "meta":{
      "grade":"9",
      "viewing_time":"2 hours; 16 minutes",
      "active_reading_time":"1 hour; 20 minutes (58%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":3,
      "__question_upvotes_student_gave":5,
      "__comment_upvotes_student_received":11,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"59540503",
    "grade":"7.2",
    "meta":{
      "grade":"7.2",
      "viewing_time":"3 hours; 46 minutes",
      "active_reading_time":"2 hours; 8 minutes (57%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":8,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":10,
      "__question_upvotes_student_received":6
    },
    "entry_id":6
  },
  {
    "userID":"52682411",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"2 hours; 58 minutes",
      "active_reading_time":"1 hour; 30 minutes (50%)",
      "__annotations":12,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":5,
      "__comment_upvotes_student_received":19,
      "__question_upvotes_student_received":3
    },
    "entry_id":6
  },
  {
    "userID":"29376337",
    "grade":"4.1",
    "meta":{
      "grade":"4.1",
      "viewing_time":"52 minutes",
      "active_reading_time":"49 minutes (95%)",
      "__annotations":3,
      "__comment_upvotes_student_gave":1,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":2,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"74886921",
    "grade":"6.7",
    "meta":{
      "grade":"6.7",
      "viewing_time":"46 minutes",
      "active_reading_time":"39 minutes (84%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":5,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":7
    },
    "entry_id":6
  },
  {
    "userID":"55571292",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"9 hours; 47 minutes",
      "active_reading_time":"6 hours; 17 minutes (64%)",
      "__annotations":9,
      "__comment_upvotes_student_gave":17,
      "__question_upvotes_student_gave":10,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"45844627",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"10 hours; 16 minutes",
      "active_reading_time":"6 hours; 14 minutes (61%)",
      "__annotations":14,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":4,
      "__comment_upvotes_student_received":23,
      "__question_upvotes_student_received":9
    },
    "entry_id":6
  },
  {
    "userID":"53036575",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"7 hours; 32 minutes",
      "active_reading_time":"5 hours; 54 minutes (78%)",
      "__annotations":29,
      "__comment_upvotes_student_gave":10,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":36,
      "__question_upvotes_student_received":13
    },
    "entry_id":6
  },
  {
    "userID":"16967126",
    "grade":"8.5",
    "meta":{
      "grade":"8.5",
      "viewing_time":"32 minutes",
      "active_reading_time":"25 minutes (80%)",
      "__annotations":9,
      "__comment_upvotes_student_gave":8,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":11,
      "__question_upvotes_student_received":3
    },
    "entry_id":6
  },
  {
    "userID":"50326251",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"4 hours; 55 minutes",
      "active_reading_time":"2 hours; 37 minutes (53%)",
      "__annotations":11,
      "__comment_upvotes_student_gave":7,
      "__question_upvotes_student_gave":4,
      "__comment_upvotes_student_received":18,
      "__question_upvotes_student_received":4
    },
    "entry_id":6
  },
  {
    "userID":"23744275",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"3 hours; 30 minutes",
      "active_reading_time":"3 hours; 21 minutes (96%)",
      "__annotations":31,
      "__comment_upvotes_student_gave":3,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":27,
      "__question_upvotes_student_received":4
    },
    "entry_id":6
  },
  {
    "userID":"24585559",
    "grade":"8.9",
    "meta":{
      "grade":"8.9",
      "viewing_time":"5 hours; 54 minutes",
      "active_reading_time":"2 hours; 24 minutes (41%)",
      "__annotations":9,
      "__comment_upvotes_student_gave":7,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":11,
      "__question_upvotes_student_received":4
    },
    "entry_id":6
  },
  {
    "userID":"54264654",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"7 hours; 33 minutes",
      "active_reading_time":"3 hours; 2 minutes (40%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":9,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":24,
      "__question_upvotes_student_received":14
    },
    "entry_id":6
  },
  {
    "userID":"31665008",
    "grade":"9.1",
    "meta":{
      "grade":"9.1",
      "viewing_time":"3 hours; 32 minutes",
      "active_reading_time":"2 hours; 23 minutes (68%)",
      "__annotations":12,
      "__comment_upvotes_student_gave":16,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"28624178",
    "grade":"1.0",
    "meta":{
      "grade":"1",
      "viewing_time":"2 hours; 52 minutes",
      "active_reading_time":"57 minutes (33%)",
      "__annotations":0,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"45476233",
    "grade":"9.3",
    "meta":{
      "grade":"9.3",
      "viewing_time":"22 minutes",
      "active_reading_time":"21 minutes (94%)",
      "__annotations":21,
      "__comment_upvotes_student_gave":20,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":4,
      "__question_upvotes_student_received":8
    },
    "entry_id":6
  },
  {
    "userID":"23400528",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"6 hours; 23 minutes",
      "active_reading_time":"4 hours; 25 minutes (69%)",
      "__annotations":11,
      "__comment_upvotes_student_gave":13,
      "__question_upvotes_student_gave":8,
      "__comment_upvotes_student_received":12,
      "__question_upvotes_student_received":1
    },
    "entry_id":6
  },
  {
    "userID":"86899376",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"18 hours; 3 minutes",
      "active_reading_time":"3 hours; 34 minutes (20%)",
      "__annotations":19,
      "__comment_upvotes_student_gave":5,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":10,
      "__question_upvotes_student_received":11
    },
    "entry_id":6
  },
  {
    "userID":"28332183",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"1 hour; 45 minutes",
      "active_reading_time":"1 hour; 20 minutes (77%)",
      "__annotations":14,
      "__comment_upvotes_student_gave":34,
      "__question_upvotes_student_gave":12,
      "__comment_upvotes_student_received":4,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"20380320",
    "grade":"8.5",
    "meta":{
      "grade":"8.5",
      "viewing_time":"2 hours; 19 minutes",
      "active_reading_time":"1 hour (43%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":11,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":7,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"21276717",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"4 hours; 19 minutes",
      "active_reading_time":"2 hours; 53 minutes (67%)",
      "__annotations":66,
      "__comment_upvotes_student_gave":11,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":3,
      "__question_upvotes_student_received":10
    },
    "entry_id":6
  },
  {
    "userID":"46666218",
    "grade":"7.5",
    "meta":{
      "grade":"7.5",
      "viewing_time":"1 hour; 29 minutes",
      "active_reading_time":"1 hour; 14 minutes (84%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":9,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":6,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"35683215",
    "grade":"9.9",
    "meta":{
      "grade":"9.9",
      "viewing_time":"3 hours; 53 minutes",
      "active_reading_time":"3 hours; 33 minutes (91%)",
      "__annotations":11,
      "__comment_upvotes_student_gave":8,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":26,
      "__question_upvotes_student_received":4
    },
    "entry_id":6
  },
  {
    "userID":"42345728",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"7 hours; 19 minutes",
      "active_reading_time":"6 hours; 19 minutes (86%)",
      "__annotations":37,
      "__comment_upvotes_student_gave":10,
      "__question_upvotes_student_gave":5,
      "__comment_upvotes_student_received":7,
      "__question_upvotes_student_received":7
    },
    "entry_id":6
  },
  {
    "userID":"46647543",
    "grade":"8.3",
    "meta":{
      "grade":"8.3",
      "viewing_time":"1 hour; 48 minutes",
      "active_reading_time":"1 hour; 23 minutes (77%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":3,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"77161172",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"6 hours; 12 minutes",
      "active_reading_time":"2 hours; 33 minutes (41%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":5,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":4,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"41149744",
    "grade":"1.0",
    "meta":{
      "grade":"1",
      "viewing_time":"9 minutes",
      "active_reading_time":"8 minutes (92%)",
      "__annotations":0,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"48905367",
    "grade":"9.9",
    "meta":{
      "grade":"9.9",
      "viewing_time":"5 hours; 33 minutes",
      "active_reading_time":"3 hours; 55 minutes (70%)",
      "__annotations":11,
      "__comment_upvotes_student_gave":7,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":12,
      "__question_upvotes_student_received":9
    },
    "entry_id":6
  },
  {
    "userID":"41393783",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"1 hour; 48 minutes",
      "active_reading_time":"1 hour; 44 minutes (96%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":5,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":22,
      "__question_upvotes_student_received":2
    },
    "entry_id":6
  },
  {
    "userID":"55249485",
    "grade":"5.7",
    "meta":{
      "grade":"5.7",
      "viewing_time":"2 hours; 31 minutes",
      "active_reading_time":"1 hour; 39 minutes (66%)",
      "__annotations":4,
      "__comment_upvotes_student_gave":1,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":1
    },
    "entry_id":6
  },
  {
    "userID":"81888190",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"2 hours; 29 minutes",
      "active_reading_time":"2 hours; 23 minutes (96%)",
      "__annotations":19,
      "__comment_upvotes_student_gave":33,
      "__question_upvotes_student_gave":7,
      "__comment_upvotes_student_received":9,
      "__question_upvotes_student_received":1
    },
    "entry_id":6
  },
  {
    "userID":"38152009",
    "grade":"1.0",
    "meta":{
      "grade":"1",
      "viewing_time":"0 minutes",
      "active_reading_time":"0 minutes",
      "__annotations":0,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"48470625",
    "grade":"1.0",
    "meta":{
      "grade":"1",
      "viewing_time":"3 minutes",
      "active_reading_time":"3 minutes (98%)",
      "__annotations":0,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"20936679",
    "grade":"8.2",
    "meta":{
      "grade":"8.2",
      "viewing_time":"2 hours; 47 minutes",
      "active_reading_time":"2 hours; 31 minutes (90%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":18,
      "__question_upvotes_student_received":1
    },
    "entry_id":6
  },
  {
    "userID":"96955357",
    "grade":"9.3",
    "meta":{
      "grade":"9.3",
      "viewing_time":"21 hours; 46 minutes",
      "active_reading_time":"20 hours; 54 minutes (96%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":8,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":5
    },
    "entry_id":6
  },
  {
    "userID":"18298956",
    "grade":"9.6",
    "meta":{
      "grade":"9.6",
      "viewing_time":"23 minutes",
      "active_reading_time":"20 minutes (89%)",
      "__annotations":13,
      "__comment_upvotes_student_gave":12,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":13,
      "__question_upvotes_student_received":11
    },
    "entry_id":6
  },
  {
    "userID":"27034712",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"13 hours; 18 minutes",
      "active_reading_time":"6 hours; 13 minutes (47%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":11,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":12,
      "__question_upvotes_student_received":3
    },
    "entry_id":6
  },
  {
    "userID":"90434281",
    "grade":"8.2",
    "meta":{
      "grade":"8.2",
      "viewing_time":"13 hours; 9 minutes",
      "active_reading_time":"3 hours; 48 minutes (29%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":8,
      "__question_upvotes_student_gave":6,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":0
    },
    "entry_id":6
  },
  {
    "userID":"27817769",
    "grade":"7.5",
    "meta":{
      "grade":"7.5",
      "viewing_time":"7 hours; 14 minutes",
      "active_reading_time":"2 hours; 36 minutes (36%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":8,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":3,
      "__question_upvotes_student_received":7
    },
    "entry_id":6
  },
  {
    "userID":"41898388",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"2 hours; 48 minutes",
      "active_reading_time":"2 hours; 18 minutes (82%)",
      "__annotations":22,
      "__comment_upvotes_student_gave":15,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":24,
      "__question_upvotes_student_received":2
    },
    "entry_id":6
  },
  {
    "userID":"76262947",
    "grade":"6.2",
    "meta":{
      "grade":"6.2",
      "viewing_time":"21 minutes",
      "active_reading_time":"18 minutes (88%)",
      "__annotations":6,
      "__comment_upvotes_student_gave":4,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":4,
      "__question_upvotes_student_received":1
    },
    "entry_id":6
  },
  {
    "userID":"22976781",
    "grade":"7.6",
    "meta":{
      "grade":"7.6",
      "viewing_time":"49 minutes",
      "active_reading_time":"26 minutes (52%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":3
    },
    "entry_id":7
  },
  {
    "userID":"43754947",
    "grade":"8.2",
    "meta":{
      "grade":"8.2",
      "viewing_time":"1 hour; 33 minutes",
      "active_reading_time":"1 hour; 29 minutes (96%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":11,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":4,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"95366984",
    "grade":"5.9",
    "meta":{
      "grade":"5.9",
      "viewing_time":"4 hours; 20 minutes",
      "active_reading_time":"3 hours; 9 minutes (73%)",
      "__annotations":3,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"70805720",
    "grade":"8.8",
    "meta":{
      "grade":"8.8",
      "viewing_time":"1 minute",
      "active_reading_time":"0 minutes (0%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":7,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":11,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"74114284",
    "grade":"4.8",
    "meta":{
      "grade":"4.8",
      "viewing_time":"3 hours; 11 minutes",
      "active_reading_time":"1 hour; 24 minutes (44%)",
      "__annotations":2,
      "__comment_upvotes_student_gave":11,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":3,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"97222205",
    "grade":"1.0",
    "meta":{
      "grade":"1",
      "viewing_time":"2 hours; 8 minutes",
      "active_reading_time":"2 minutes (2%)",
      "__annotations":0,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"66889858",
    "grade":"9.8",
    "meta":{
      "grade":"9.8",
      "viewing_time":"9 hours; 57 minutes",
      "active_reading_time":"8 hours; 30 minutes (85%)",
      "__annotations":13,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":7,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"96600883",
    "grade":"5.2",
    "meta":{
      "grade":"5.2",
      "viewing_time":"53 minutes",
      "active_reading_time":"52 minutes (98%)",
      "__annotations":4,
      "__comment_upvotes_student_gave":5,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"32324131",
    "grade":"1.0",
    "meta":{
      "grade":"1",
      "viewing_time":"0 minutes",
      "active_reading_time":"0 minutes",
      "__annotations":0,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"41803722",
    "grade":"8.4",
    "meta":{
      "grade":"8.4",
      "viewing_time":"3 hours; 55 minutes",
      "active_reading_time":"2 hours; 21 minutes (60%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":13,
      "__question_upvotes_student_gave":14,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":2
    },
    "entry_id":7
  },
  {
    "userID":"81005245",
    "grade":"9.3",
    "meta":{
      "grade":"9.3",
      "viewing_time":"2 hours; 29 minutes",
      "active_reading_time":"2 hours; 12 minutes (89%)",
      "__annotations":9,
      "__comment_upvotes_student_gave":5,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":19,
      "__question_upvotes_student_received":4
    },
    "entry_id":7
  },
  {
    "userID":"35251913",
    "grade":"2.4",
    "meta":{
      "grade":"2.4",
      "viewing_time":"0 minutes",
      "active_reading_time":"0 minutes (0%)",
      "__annotations":2,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"43219917",
    "grade":"8.7",
    "meta":{
      "grade":"8.7",
      "viewing_time":"43 minutes",
      "active_reading_time":"29 minutes (69%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":4,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":11,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"59540503",
    "grade":"8.5",
    "meta":{
      "grade":"8.5",
      "viewing_time":"4 hours; 17 minutes",
      "active_reading_time":"2 hours; 4 minutes (48%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":4,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":13,
      "__question_upvotes_student_received":1
    },
    "entry_id":7
  },
  {
    "userID":"52682411",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"1 hour; 46 minutes",
      "active_reading_time":"1 hour; 39 minutes (93%)",
      "__annotations":16,
      "__comment_upvotes_student_gave":8,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":16,
      "__question_upvotes_student_received":1
    },
    "entry_id":7
  },
  {
    "userID":"29376337",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"4 hours; 7 minutes",
      "active_reading_time":"2 hours; 51 minutes (69%)",
      "__annotations":26,
      "__comment_upvotes_student_gave":10,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":27,
      "__question_upvotes_student_received":3
    },
    "entry_id":7
  },
  {
    "userID":"74886921",
    "grade":"9.0",
    "meta":{
      "grade":"9",
      "viewing_time":"1 hour; 46 minutes",
      "active_reading_time":"1 hour; 26 minutes (81%)",
      "__annotations":11,
      "__comment_upvotes_student_gave":4,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":18,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"55571292",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"6 hours; 41 minutes",
      "active_reading_time":"4 hours; 8 minutes (62%)",
      "__annotations":9,
      "__comment_upvotes_student_gave":33,
      "__question_upvotes_student_gave":5,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":2
    },
    "entry_id":7
  },
  {
    "userID":"45844627",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"3 hours; 58 minutes",
      "active_reading_time":"2 hours; 19 minutes (58%)",
      "__annotations":14,
      "__comment_upvotes_student_gave":5,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":10,
      "__question_upvotes_student_received":2
    },
    "entry_id":7
  },
  {
    "userID":"53036575",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"4 hours; 10 minutes",
      "active_reading_time":"3 hours; 47 minutes (91%)",
      "__annotations":14,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":8,
      "__question_upvotes_student_received":7
    },
    "entry_id":7
  },
  {
    "userID":"16967126",
    "grade":"8.9",
    "meta":{
      "grade":"8.9",
      "viewing_time":"5 minutes",
      "active_reading_time":"3 minutes (68%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":8,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":11,
      "__question_upvotes_student_received":2
    },
    "entry_id":7
  },
  {
    "userID":"50326251",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"6 hours; 29 minutes",
      "active_reading_time":"2 hours; 8 minutes (33%)",
      "__annotations":12,
      "__comment_upvotes_student_gave":16,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":8,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"23744275",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"2 hours; 32 minutes",
      "active_reading_time":"2 hours; 15 minutes (89%)",
      "__annotations":29,
      "__comment_upvotes_student_gave":4,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":43,
      "__question_upvotes_student_received":2
    },
    "entry_id":7
  },
  {
    "userID":"24585559",
    "grade":"8.1",
    "meta":{
      "grade":"8.1",
      "viewing_time":"41 minutes",
      "active_reading_time":"40 minutes (98%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":7,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":13,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"54264654",
    "grade":"7.9",
    "meta":{
      "grade":"7.9",
      "viewing_time":"2 hours; 49 minutes",
      "active_reading_time":"1 hour; 45 minutes (62%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":12,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":5,
      "__question_upvotes_student_received":2
    },
    "entry_id":7
  },
  {
    "userID":"31665008",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"4 hours; 12 minutes",
      "active_reading_time":"2 hours; 38 minutes (63%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":8,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":7,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"28624178",
    "grade":"1.0",
    "meta":{
      "grade":"1",
      "viewing_time":"1 hour; 43 minutes",
      "active_reading_time":"1 hour; 12 minutes (70%)",
      "__annotations":0,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"45476233",
    "grade":"8.7",
    "meta":{
      "grade":"8.7",
      "viewing_time":"0 minutes",
      "active_reading_time":"0 minutes (0%)",
      "__annotations":12,
      "__comment_upvotes_student_gave":7,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":4,
      "__question_upvotes_student_received":3
    },
    "entry_id":7
  },
  {
    "userID":"23400528",
    "grade":"9.3",
    "meta":{
      "grade":"9.3",
      "viewing_time":"3 hours; 59 minutes",
      "active_reading_time":"2 hours; 15 minutes (57%)",
      "__annotations":11,
      "__comment_upvotes_student_gave":14,
      "__question_upvotes_student_gave":8,
      "__comment_upvotes_student_received":2,
      "__question_upvotes_student_received":3
    },
    "entry_id":7
  },
  {
    "userID":"86899376",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"7 hours; 33 minutes",
      "active_reading_time":"2 hours; 34 minutes (34%)",
      "__annotations":24,
      "__comment_upvotes_student_gave":7,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":22,
      "__question_upvotes_student_received":2
    },
    "entry_id":7
  },
  {
    "userID":"28332183",
    "grade":"9.9",
    "meta":{
      "grade":"9.9",
      "viewing_time":"2 hours; 11 minutes",
      "active_reading_time":"2 hours; 8 minutes (97%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":11,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":3,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"20380320",
    "grade":"9.8",
    "meta":{
      "grade":"9.8",
      "viewing_time":"3 hours; 8 minutes",
      "active_reading_time":"1 hour; 57 minutes (62%)",
      "__annotations":9,
      "__comment_upvotes_student_gave":3,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":9,
      "__question_upvotes_student_received":7
    },
    "entry_id":7
  },
  {
    "userID":"21276717",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"5 hours; 52 minutes",
      "active_reading_time":"3 hours; 46 minutes (64%)",
      "__annotations":50,
      "__comment_upvotes_student_gave":3,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":11,
      "__question_upvotes_student_received":9
    },
    "entry_id":7
  },
  {
    "userID":"46666218",
    "grade":"7.8",
    "meta":{
      "grade":"7.8",
      "viewing_time":"53 minutes",
      "active_reading_time":"49 minutes (92%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":8,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":4,
      "__question_upvotes_student_received":2
    },
    "entry_id":7
  },
  {
    "userID":"35683215",
    "grade":"7.9",
    "meta":{
      "grade":"7.9",
      "viewing_time":"57 minutes",
      "active_reading_time":"43 minutes (75%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":2,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":4,
      "__question_upvotes_student_received":5
    },
    "entry_id":7
  },
  {
    "userID":"42345728",
    "grade":"9.2",
    "meta":{
      "grade":"9.2",
      "viewing_time":"4 hours; 15 minutes",
      "active_reading_time":"3 hours; 3 minutes (72%)",
      "__annotations":24,
      "__comment_upvotes_student_gave":9,
      "__question_upvotes_student_gave":4,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"46647543",
    "grade":"8.0",
    "meta":{
      "grade":"8",
      "viewing_time":"3 hours; 47 minutes",
      "active_reading_time":"1 hour; 30 minutes (40%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":1,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"77161172",
    "grade":"7.2",
    "meta":{
      "grade":"7.2",
      "viewing_time":"4 hours; 16 minutes",
      "active_reading_time":"1 hour; 57 minutes (46%)",
      "__annotations":5,
      "__comment_upvotes_student_gave":1,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":2
    },
    "entry_id":7
  },
  {
    "userID":"41149744",
    "grade":"1.0",
    "meta":{
      "grade":"1",
      "viewing_time":"1 minute",
      "active_reading_time":"1 minute (76%)",
      "__annotations":0,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"48905367",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"16 hours; 15 minutes",
      "active_reading_time":"15 hours; 51 minutes (97%)",
      "__annotations":15,
      "__comment_upvotes_student_gave":7,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":22,
      "__question_upvotes_student_received":6
    },
    "entry_id":7
  },
  {
    "userID":"41393783",
    "grade":"9.0",
    "meta":{
      "grade":"9",
      "viewing_time":"1 hour; 55 minutes",
      "active_reading_time":"1 hour; 44 minutes (91%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":5,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":11,
      "__question_upvotes_student_received":3
    },
    "entry_id":7
  },
  {
    "userID":"55249485",
    "grade":"9.1",
    "meta":{
      "grade":"9.1",
      "viewing_time":"2 hours; 18 minutes",
      "active_reading_time":"1 hour; 39 minutes (71%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":5,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":9,
      "__question_upvotes_student_received":7
    },
    "entry_id":7
  },
  {
    "userID":"81888190",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"1 hour; 20 minutes",
      "active_reading_time":"1 hour; 19 minutes (98%)",
      "__annotations":35,
      "__comment_upvotes_student_gave":28,
      "__question_upvotes_student_gave":12,
      "__comment_upvotes_student_received":12,
      "__question_upvotes_student_received":1
    },
    "entry_id":7
  },
  {
    "userID":"38152009",
    "grade":"4.0",
    "meta":{
      "grade":"4",
      "viewing_time":"7 minutes",
      "active_reading_time":"4 minutes (57%)",
      "__annotations":5,
      "__comment_upvotes_student_gave":3,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":1
    },
    "entry_id":7
  },
  {
    "userID":"48470625",
    "grade":"7.6",
    "meta":{
      "grade":"7.6",
      "viewing_time":"50 minutes",
      "active_reading_time":"48 minutes (97%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":0,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":0,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"20936679",
    "grade":"5.7",
    "meta":{
      "grade":"5.7",
      "viewing_time":"1 hour; 58 minutes",
      "active_reading_time":"1 hour; 40 minutes (84%)",
      "__annotations":4,
      "__comment_upvotes_student_gave":2,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":8,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"96955357",
    "grade":"5.0",
    "meta":{
      "grade":"5",
      "viewing_time":"52 minutes",
      "active_reading_time":"24 minutes (45%)",
      "__annotations":5,
      "__comment_upvotes_student_gave":4,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":5,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"18298956",
    "grade":"8.8",
    "meta":{
      "grade":"8.8",
      "viewing_time":"51 minutes",
      "active_reading_time":"50 minutes (97%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":1,
      "__comment_upvotes_student_received":5,
      "__question_upvotes_student_received":1
    },
    "entry_id":7
  },
  {
    "userID":"27034712",
    "grade":"10.0",
    "meta":{
      "grade":"10",
      "viewing_time":"4 hours; 4 minutes",
      "active_reading_time":"2 hours; 25 minutes (60%)",
      "__annotations":8,
      "__comment_upvotes_student_gave":4,
      "__question_upvotes_student_gave":2,
      "__comment_upvotes_student_received":4,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"90434281",
    "grade":"9.5",
    "meta":{
      "grade":"9.5",
      "viewing_time":"18 hours; 26 minutes",
      "active_reading_time":"17 hours; 2 minutes (92%)",
      "__annotations":10,
      "__comment_upvotes_student_gave":6,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":4,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"27817769",
    "grade":"7.0",
    "meta":{
      "grade":"7",
      "viewing_time":"8 hours; 11 minutes",
      "active_reading_time":"1 hour; 45 minutes (21%)",
      "__annotations":6,
      "__comment_upvotes_student_gave":1,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":3,
      "__question_upvotes_student_received":0
    },
    "entry_id":7
  },
  {
    "userID":"41898388",
    "grade":"9.5",
    "meta":{
      "grade":"9.5",
      "viewing_time":"3 hours; 50 minutes",
      "active_reading_time":"1 hour; 40 minutes (44%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":3,
      "__question_upvotes_student_gave":0,
      "__comment_upvotes_student_received":9,
      "__question_upvotes_student_received":2
    },
    "entry_id":7
  },
  {
    "userID":"76262947",
    "grade":"7.8",
    "meta":{
      "grade":"7.8",
      "viewing_time":"42 minutes",
      "active_reading_time":"40 minutes (95%)",
      "__annotations":7,
      "__comment_upvotes_student_gave":7,
      "__question_upvotes_student_gave":3,
      "__comment_upvotes_student_received":1,
      "__question_upvotes_student_received":5
    },
    "entry_id":7
  }
]
